import { render, staticRenderFns } from "./AdminRecordsSearch.vue?vue&type=template&id=6842f114&"
import script from "./AdminRecordsSearch.vue?vue&type=script&lang=js&"
export * from "./AdminRecordsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports